var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"grey-lighten-4--text lighten-3",attrs:{"outlined":"","href":"/start/github"}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v(" mdi-github ")]),_vm._v(" GitHub ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }